import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShapesPlusXSquareCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShapesPlusXSquareCircle"><Path d="M7 3.5V7M7 7V10.5M7 7H3.5M7 7H10.5M20.4749 14.5251L18 17M18 17L15.5251 19.4749M18 17L15.5251 14.5251M18 17L20.4749 19.4749M3.5 13.5H10.5V20.5H3.5V13.5ZM18 10.5C16.067 10.5 14.5 8.933 14.5 7C14.5 5.067 16.067 3.5 18 3.5C19.933 3.5 21.5 5.067 21.5 7C21.5 8.933 19.933 10.5 18 10.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShapesPlusXSquareCircle;
